import * as React from 'react';
import ColorImageForm from "../../components/ColorImages/ColorImageForm/ColorImageForm";
var ColorImage = function () {
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432 \u0446\u0432\u0435\u0442\u043E\u0432\u0430 \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0430"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-5 offset-md-4" },
                    React.createElement(ColorImageForm, null))))));
};
export default ColorImage;



//////////////////
// WEBPACK FOOTER
// ./src/views/ColorImages/ColorImage.tsx
// module id = 336
// module chunks = 0